export default __webpack_public_path__ + "static/media/DtVnJx26TKEr37c9aBBx_kwEzg38pQhMruE.06836b50.woff2";